import CustomModal from "Components/CommonComponents/CustomModal";
import Typography from "Components/CommonComponents/Typography";
import {
  ToastContextDispatch,
  SuccessfullyMessageBarDispatch,
} from "Context/CommonContext";
import { Col, Row, Spinner } from "reactstrap";
import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import React, { useContext, useState } from "react";
import { convertFormValuesToFormData } from "utilFunctions/helperFunctions/convertFormValuesToFormData";
import { ADD_DOCUMENT, BASE_URL } from "utilFunctions/Constants/urlConstants";
import { useNavigate } from "react-router";
import { academicPhase } from "utilFunctions/Constants/Constants";
import { Button, Space } from "antd";

const UploadPlannerFileModal = (props: any) => {
  const navigate = useNavigate();
  const {
    filterState,
    filterDataValue,
    toggle,
    subjects,
    stream,
    acadYears,
    classes,
    docTypes,
  } = props;
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const successMessageInfor = useContext<any>(SuccessfullyMessageBarDispatch);
  const [warningMessage, setwarningMessage] = useState<string>("");
  const { makeRequest: postUploadPlannerUpload, loading } = usePutPostAPI(
    (data) => {
      if (data && data["data"] && data["data"].showPopup) {
        toggle();
        setwarningMessage(data["data"]?.popupMessage);
      } else {
        setwarningMessage("");
        toggle();
        successMessageInfor({
          message: "Document uploaded successfully!",
          isShow: true,
        });
        navigate("/admin/planner", {
          replace: true,
          state: {
            isSuccess: true,
          },
        });
      }
    },
    (error) => {
      setwarningMessage("");
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: error["response"]["data"]["message"],
      });
    },
    "POST"
  );

  const uploadDocumentPlannerHandler = (doValidation: string) => {
    filterDataValue["doValidation"] = doValidation;
    const formData: any = convertFormValuesToFormData(filterDataValue);
    postUploadPlannerUpload(BASE_URL + ADD_DOCUMENT, formData);
  };
  const getFieldsNameFromArr = (item: any, arr: any) => {
    if (typeof item != "object") {
      const findItem = arr?.find((ele: any) => ele.value == item)?.label;
      return findItem;
    } else {
      if (item) {
        const findItem = arr
          .filter((ele: any) => item.includes(ele.value))
          .map((el: any) => el.label)
          ?.join(", ");
        return findItem;
      }
      return null;
    }
  };
  const returnName = (ele: any, chipsFields: any) => {
    console.log("itemitemitemitem", ele, chipsFields);
    if (ele === "classList") {
      return getFieldsNameFromArr(chipsFields[ele], classes);
    } else if (ele === "phaseList") {
      return getFieldsNameFromArr(chipsFields[ele], academicPhase);
    } else if (ele === "subjectList") {
      return getFieldsNameFromArr(chipsFields[ele], subjects);
    } else if (ele === "streamId") {
      return getFieldsNameFromArr(chipsFields[ele], stream);
    } else if (ele === "acadYearId") {
      return getFieldsNameFromArr(chipsFields[ele], acadYears);
    } else if (ele === "documentTypeId") {
      return getFieldsNameFromArr(chipsFields[ele], docTypes);
    }
    return null;
  };
  console.log("filterStatefilterState", filterState);
  return (
    <div>
      <CustomModal
        centered={true}
        backdrop={true}
        title={warningMessage}
        modal={warningMessage != ""}
        toggle={() => {
          setwarningMessage("");
        }}
        className={"mw-60"}
      >
        <div className="mb-4 d-flex justify-content-center">
          <Button
            disabled={loading}
            type="primary"
            onClick={() => {
              uploadDocumentPlannerHandler("0");
            }}
          >
            Confirm
          </Button>
          <Button
            className="cancelButton"
            onClick={() => {
              setwarningMessage("");
            }}
          >
            Cancel
          </Button>
        </div>
      </CustomModal>
      <CustomModal
        centered={true}
        backdrop={true}
        title="Are you sure you want to upload this document?"
        modal={props.modal}
        toggle={toggle}
        className={"mw-60"}
      >
        {loading ? (
          <div className="w-100 d-flex justify-content-center py-5">
            <Spinner color="info"></Spinner>
          </div>
        ) : (
          <div>
            <Row className="w-100">
              <Col md="4">
                <Typography variant="subheading3" color="black">
                  Document Title
                </Typography>
                <Typography variant="subheading2" color="black">
                  {filterState.title}
                </Typography>
              </Col>
              <Col md="4">
                <Typography variant="subheading3" color="black">
                  Stream
                </Typography>
                <Typography variant="subheading2" color="black">
                  {returnName("streamId", filterState)}
                </Typography>
              </Col>
              <Col md="4">
                <Typography variant="subheading3" color="black">
                  Acedemic Year
                </Typography>
                <Typography variant="subheading2" color="black">
                  {returnName("acadYearId", filterState)}
                </Typography>
              </Col>
            </Row>
            <Row className="w-100 mt-4 mb-4">
              <Col md="4">
                <Typography variant="subheading3" color="black">
                  Class
                </Typography>
                <Typography variant="subheading2" color="black">
                  {returnName("classList", filterState)}
                </Typography>
              </Col>
              {filterState.phaseList != null &&
              filterState.phaseList.length > 0 ? (
                <Col md="4">
                  <Typography variant="subheading3" color="black">
                    Phase
                  </Typography>
                  <Typography variant="subheading2" color="black">
                    {returnName("phaseList", filterState)}
                  </Typography>
                </Col>
              ) : null}
              <Col md="4">
                <Typography variant="subheading3" color="black">
                  Document Type
                </Typography>
                <Typography variant="subheading2" color="black">
                  {returnName("documentTypeId", filterState)}
                </Typography>
              </Col>
            </Row>
            <Row className="w-100 mt-4 mb-4">
              {filterState.subjectList != null &&
              filterState.subjectList.length > 0 ? (
                <Col md="4">
                  <Typography variant="subheading3" color="black">
                    Subject
                  </Typography>
                  <Typography variant="subheading2" color="black">
                    {returnName("subjectList", filterState)}
                  </Typography>
                </Col>
              ) : null}
              <Col md="4">
                <Typography variant="subheading3" color="black">
                  File Name
                </Typography>
                <Typography variant="subheading2" color="black">
                  {filterState.fileName}
                </Typography>
              </Col>
            </Row>
            <div className="mb-4">
              <Space>
                <Button
                  disabled={loading}
                  type="primary"
                  onClick={() => {
                    uploadDocumentPlannerHandler("1");
                  }}
                >
                  {loading ? (
                    <Spinner color="info" size="sm"></Spinner>
                  ) : (
                    "Upload File"
                  )}
                </Button>
                <Button type="default" onClick={toggle}>
                  {loading ? (
                    <Spinner color="info" size="sm"></Spinner>
                  ) : (
                    "Cancel"
                  )}
                </Button>
              </Space>
            </div>
          </div>
        )}
      </CustomModal>
    </div>
  );
};
export default UploadPlannerFileModal;
